import { SessionContext } from '../../context/session-context'
import { useContext } from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'

export const ProtectedRoute = ({ component: Component, ...restOfProps }: RouteProps): React.ReactElement => {
  const { isLoggedIn } = useContext(SessionContext)
  const renderFn = (props: any): any => (isLoggedIn && Component ? <Component {...props} /> : <Redirect to="/login" />)
  return <Route {...restOfProps} render={renderFn} />
}
